import { defineRecipe } from '@chakra-ui/react';

/** Inactive and active colors. The component blends them while a carousel drags. */
export const carouselDotsRecipe = defineRecipe({
  base: {
    '--dot-muted': 'colors.border',
    '--dot-active': 'colors.accent',
  },
});
